module.exports = __webpack_public_path__ + "img/GoodhandsWaterSpecialist_logo@2x.31467bcd.png";